import { mutations } from './mutations';
import { getters } from './getters';
import { SessionState } from './state';

const defaultState: SessionState = {
  filtersMap: {
    devicereports: {
      most_recent: true,
      is_active: true
    },
    sitereports: {
      most_recent: true,
      is_active: true
    },
    tcreports: {
      most_recent: true,
      is_active: true
    }
  },
  advancedSearchVisibleMap: {},
  tableOptionsMap: {},
  choiceCache: {},
  deviceGroupID: 1,
  statusID: 3
};

export const sessionModule = {
  state: defaultState,
  mutations,
  getters
};
